import React from 'react';
import PropTypes from 'prop-types';
import CustomButton from "../../../../../../components/CustomButton";
import {FormattedMessage} from "react-intl";

AddRetailerButton.propTypes = {
    selectedRetailers: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired
};

function AddRetailerButton({selectedRetailers, onClick}) {
    function hasSelectedRetailers() {
        return Object.values(selectedRetailers).filter(value => value === true);
    }

    return (
        <CustomButton
            disabled={!hasSelectedRetailers()}
            fullWidth={true}
            thicker={true}
            onClick={onClick}
        >
            {hasSelectedRetailers().length > 1 ? (
                <FormattedMessage id='wms.myPickingMissions.add.retailer.add.multiple' />
            ) : (
                <FormattedMessage id='wms.myPickingMissions.add.retailer.add' />
            )}
        </CustomButton>
    );
}

export default AddRetailerButton;
